module.exports = __webpack_public_path__ + "static/media/chef_03.5d109110.png";